<!-- Dashboard start -->
<!-- END: Left Aside -->

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="vendorUserForm">
  <!--MAIN-->
  <div class="m-content">
    <form
        [formGroup]="vendorUserForm"
        class="m-form m-form--fit m-form--label-align-right"
      >
      
    <!--begin::Portlet-->
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!vendorId">
              VENDOR USER DETAILS
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="vendorId">
              EDIT VENDOR USER
            </h3>
          </div>
        </div>
      </div>

      <!--begin::Form-->
      
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Vendor:
              </label>
              <div class="col-lg-4">
                <select
                  formControlName="vendorId"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="vendorId"
                  name="vendorIdSelect"
                >
                  <option selected value="0">-- Select an Existing Vendor --</option>
                  <option
                    *ngFor="let vendor of vendors"
                    [selected]="vendor.vendorId == vendorUserForm.controls.vendorId.value"
                    [value]="vendor.vendorId"    
                  >
                    {{ vendor.name }}
                  </option>
                </select>
                <app-validation-display
                  [control]="vendorUserForm.controls.vendorId"
                  errorMessage="Vendor is required"
                ></app-validation-display>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                User:
              </label>
              <div class="col-lg-4">
                <select
                  formControlName="userId"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="userId"
                  name="userIdSelect"
                  (change)="selectUser($event.target.value)"
                >
                  <option selected value="0">-- Create New User --</option>
                  <option
                    *ngFor="let user of users"
                    [selected]="user.userId == vendorUserForm.controls.userId.value"
                    [value]="user.userId"    
                  >
                    {{ user.email }}
                  </option>
                </select>
                <span class="m-form__help">
                  Choose an existing user from this list to add as a vendor user who will be capable of managing fundraising events. </span
                ><br />
                <span class="m-form__help">
                  E.g. A university that already uses the portal for fundraising, but wants to allow more than one user to manage fundraising events.</span
                >
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="m-portlet" style="width: 100%">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!editMode">
              NEW USER INFORMATION
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="editMode">
              EDIT USER INFORMATION
            </h3>
          </div>
        </div>
      </div>
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">    

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                First Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="userFirstName"
                  type="text"
                  id="primaryContactFirstName"
                  class="form-control m-input"
                />
                <app-validation-display
                    [control]="vendorUserForm.controls.userFirstName"
                    errorMessage="Please enter a valid first name"
                >
                </app-validation-display>
                <span class="m-form__help">
                  The first name of the new vendor user.</span
                >
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Last Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="userLastName"
                  type="text"
                  id="userLastName"
                  class="form-control m-input"
                />
                <app-validation-display
                    [control]="vendorUserForm.controls.userLastName"
                    errorMessage="Please enter a valid last name"
                >
                </app-validation-display>
                <span class="m-form__help">
                  The last name of the new vendor user.</span
                >
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Email:
              </label>
              <div class="col-lg-4">
                <input
                  [requiredIf]="vendorUserForm.controls.userId.value < 1"
                  formControlName="userEmail"
                  [ignoreWhiteSpace]
                  pattern='(?:[A-z0-9!#$%&amp;"*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&amp;"*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-z0-9-]*[A-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])'
                  type="text"
                  id="email"
                  class="form-control m-input"
                />
                <p 
                  style="color:red; padding: 0; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 300;" 
                  *ngIf="vendorUserForm.controls.active.value == true">
                    Cannot edit email addresses of existing users.
                </p>
                <app-validation-display
                    [control]="vendorUserForm.controls.userEmail"
                    errorMessage="Please enter a valid email"
                >
                </app-validation-display>
              </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Phone Number:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="userPhoneNumber"
                  type="text"
                  id="phonenumber"
                  pattern="^[\s.]*(\d{1,2}[\s.-]*)?\(?\d{3}\)?[\s.-]*\d{3}[\s.-]*\d{4}[\s.]*$"
                  maxlength="16"
                  class="form-control m-input"
                />
                <app-validation-display
                    [control]="vendorUserForm.controls.userPhoneNumber"
                    errorMessage="Please enter a valid phone number"
                >
                </app-validation-display>
              </div>
            </div>
            
            <div> 
             <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this date range will dictate the period of time that this user can create services"
                  />
                  Subscription Period:
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      formControlName="enableSubscriptionPeriod"
                      id="enableSubscriptionPeriod"           
                      type="checkbox"
                      (change)="enableSubscription = !enableSubscription"
                    />
                    <span [ngStyle]="{'cursor': vendorUserForm.controls.userId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
                <div class="col-lg-4">
                  <span class="m-form__help" *ngIf="vendorUserForm.controls.userId.value > 0">
                    Cannot edit this user's settings here</span
                  >
                  <app-service-period
                    *ngIf="enableSubscription && vendorUserForm.controls.userId.value < 1"
                    [minDays]="30"
                    [showTooltip]="false"
                    formControlName="period"
                  ></app-service-period>
                </div>
              </div>
            

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, after the user uploads a custom track he will be able to program the torches for it"
                  />
                  Can User Program Lightshows
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="canProgramCustomTracks"
                      formControlName="canProgramCustomTracks"
                      type="checkbox"
                    />
                    <span [ngStyle]="{'cursor': vendorUserForm.controls.userId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this user will be able to create venues and add sections to their light shows"
                  />
                  Can User Edit Venues
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="canEditVenues"
                      formControlName="canEditVenues"
                      type="checkbox"
                    />
                    <span [ngStyle]="{'cursor': vendorUserForm.controls.userId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  <img
                    src="../../assets/app/media/img/icons/info-icon.png"
                    class="tooltip-icon"
                    style="position: relative;"
                    tooltip="If enabled, this user will be able to use the Global Sync feature"
                  />
                  Can User Start Global Sync
                </label>
                <div class="col-lg-1">
                  <label class="switch">
                    <input
                      id="enableNetworkSync"
                      formControlName="enableNetworkSync"
                      type="checkbox"
                    />
                    <span [ngStyle]="{'cursor': vendorUserForm.controls.userId.value > 0 ? 'not-allowed' : 'pointer'}" class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>    
        </div>
    </div>
  </form>

    <div class="form-group m-form__group row">
      <div class="col-lg-12">
        <button [debounceClick] [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
          Create
        </button>
        <button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
          Cancel
        </button>
        <div *ngIf="validationErrors != ''">
          <span style="color:red">{{validationErrors}}</span>
        </div>
        
      </div>

    </div>
  </div>
</div>
